import { render, staticRenderFns } from "./Emun.vue?vue&type=template&id=1934124a&scoped=true&"
import script from "./Emun.vue?vue&type=script&lang=js&"
export * from "./Emun.vue?vue&type=script&lang=js&"
import style0 from "./Emun.vue?vue&type=style&index=0&id=1934124a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934124a",
  null
  
)

export default component.exports